import { Form, Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { useState } from "react";
import { userServices } from "../../APIServices/UserData/userServices";
import { authServices } from "../../APIServices/UserData/authServices";

export default function AccountSetUp({
  setNextPage,
  email,
  name,
  setName,
  setEmail,
  setLoader,
  loader,
  cardAnim,
}) {
  const [accountName, setAccountName] = useState("");
  const [description, setDescription] = useState("");

  const setUpAccount = async () => {
    setLoader(true);
    let userData = {
      email,
      name: accountName,
      description,
    };
    let data = await authServices.setUpAccount(userData);
    if (data?.status) {
      setEmail(data?.email);
      setName(data?.name);
      setNextPage("powerFullSecurity");
    }
    setLoader(false);
  };

  function getTwoInitials() {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    const first = parts[0][0];
    const last = parts[parts.length - 1][0];
    return (first + last).toUpperCase();
  }

  return (
    <>
      <motion.div key="step4" {...cardAnim}>
        <Card
          className="border-0 shadow-lg"
          style={{ borderRadius: "18px", width: 420 }}
        >
          <Card.Body className="p-4">
            <div className="text-center mb-3">
              <h4 className="fw-bold mb-1">Set your Primary Account</h4>
              <small className="text-muted">
                This password protects your vault — make it strong
              </small>
            </div>
            <Form.Group className="mb-3">
              <div className="hstack gap-2 mb-3">
                <h6 className={`bg-primary-subtle p-3 rounded-1 fw-bold m-0`}>
                  {getTwoInitials(name)}
                </h6>
                <div>
                  <h6 className="m-0">{name}</h6>
                  <p className="small m-0 text-muted">{email}</p>
                </div>
              </div>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Account Name{" "}
                <abbr className="text-danger" title="Require">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                className="interactive-input rounded-1"
                style={{ fontSize: 12, padding: "6px 15px" }}
                placeholder="Enter Account Name"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Description (optional)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="interactive-input rounded-1"
                style={{ fontSize: 12, padding: "6px 15px" }}
                placeholder="What should this account use for?"
              />
            </Form.Group>
            <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
              <Button
                onClick={setUpAccount}
                disabled={!accountName || loader}
                className="w-100 py-2 fw-bold btn-gradient"
              >
                Continue <FaArrowRight />
              </Button>
            </motion.div>
          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
}
